import CustomerFilter from './CustomerFilter'

export default CustomerFilter
